import script from "./DetailTopicLottie.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailTopicLottie.vue?vue&type=script&lang=ts&setup=true"

import "./DetailTopicLottie.vue?vue&type=style&index=0&id=7186f7cf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7186f7cf"]])

export default __exports__